import { createFileRoute } from '@tanstack/react-router';

import AccountUserAcceptInviteLoggedOut from 'component/view/AccountUsers/AcceptInviteLoggedOut';

interface UsersAcceptSearch {
  invite?: string;
  token?: string;
}

export const Route = createFileRoute('/users/accept')({
  validateSearch: (search: Record<string, unknown>): UsersAcceptSearch => {
    const invite =
      typeof search.invite === 'string' && search.invite.length > 0 ? search.invite : undefined;
    const token =
      typeof search.token === 'string' && search.token.length > 0 ? search.token : undefined;

    return {
      invite,
      token,
    };
  },
  component: AccountUserAcceptInviteLoggedOut,
});
